import FastMarquee from "react-fast-marquee";

const words = [
  "MASCARPONE",
  "ESPRESSO",
  "SAVOIARDI",
  "COCOA",
  "EGG YOLK",
  "SUGAR",
];

export default function Marquee() {
  return (
    <div className="velluto-marquee py-8 md:py-10" data-testid="ingredient-marquee">
      <FastMarquee speed={36} gradient={false} pauseOnHover>
        {words.map((w, i) => (
          <span
            key={`${w}-${i}`}
            className="font-serif italic text-[#211512] flex items-center"
            style={{ fontSize: "clamp(1.75rem, 4vw, 3.25rem)" }}
            data-testid={`marquee-word-${w.toLowerCase().replace(" ", "-")}`}
          >
            <span className="mx-10 md:mx-16">{w}</span>
            <span className="marquee-dot">✦</span>
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
